import { SolutionTag } from '@luminovo/http-client';
import { Solution } from '../types';

export function isConsignedSolution(solution: Solution): boolean {
    return solution.solutionTags.map((tag) => tag.tag).includes(SolutionTag.Consigned);
}
